/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-undef */
/* eslint-disable camelcase */
/* eslint-disable no-use-before-define */
/* eslint-disable no-const-assign */
/* eslint-disable no-shadow */
/* eslint-disable no-lone-blocks */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/jsx-no-script-url */
/* eslint-disable no-script-url */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable max-len */
/* eslint-disable react/no-array-index-key */
import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import ThreeDotsLoader from '../../../../Components/LoadingDots';
import { distributorService } from '../../../../service/distributor.service';
import { userService } from '../../../../service/user.service';
import CustomToast from '../../../../Components/AlertPopup';
import { useToast } from '../../../../context/ToastContext';

function CreateDirectOrderPopup({ directOrderPopup, setDirectOrderPopup }) {
    const location = useNavigate();
    const [searchValue, serSearchValue] = useState('');
    const [selectedDistributor, seSelectedDistributor] = useState('');
    const [selectedOrder, seSelectedOrder] = useState('');
    const [orderDropDown, setOrderDropDown] = useState(false);
    const [distributorSearchResult, setdistributorSearchResult] = useState([]);
    const [distributors, setDistributors] = useState([]);
    const [orderTypes, setOrderType] = useState(['Domestic', 'Free Service', 'Demo', 'Free Samples', 'Free Replacement', 'Service', 'Repair', 'Free Supplies']);
    const [approveStatus, setApproveStatus] = useState('');
    const [buttonLoader, setButtonLoader] = useState(false);
    const [submitSelected, setsubmitSelected] = useState(false);
    const [selectedDistributorObj, setSelectedDistributorObj] = useState({});
    const [showPopup, setshowPopup] = useState(false);
    const { showToast } = useToast();
    const [errorState, setErrorState] = useState({
        distributor_id: '',
        order_type: '',
        initial_category: '',
    });
    const [permissionError, setpermissionError] = useState(false);

    const onChangeSearch = (value) => {
        serSearchValue(value);
        const roleRestiction = ['area_sales_manager', 'area_sales_engineer', 'regional_sales_manager', 'senior_area_sales_engineer'];
        const { roles } = JSON.parse(localStorage.getItem('user')).profile;
        if (roleRestiction.includes(roles)) {
            const dist = distributors.filter((val) => (val.ACCOUNT_NUMBER?.toLowerCase().includes(value.toLowerCase())
                || val.PARTY_NAME?.toLowerCase().includes(value.toLowerCase())));
            setdistributorSearchResult(dist);
        } else {
            distributorService.DistributorList(1, value, '', '').then((val) => {
                if (val.data.success_status) {
                    setdistributorSearchResult(val.data.data);
                }
            });
        }
    };

    const getUserDetails = () => {
        userService.getAdminDetailWithDistributors().then((val) => {
            if (val?.data?.success_status) {
                if (val?.data?.data?.distributors?.length > 0) {
                    distributorService.GetDistributorsName(val?.data?.data?.distributors?.join(',')).then((val) => {
                        if (val?.data?.success_status) {
                            setDistributors(val?.data?.data);
                        }
                    });
                }
            }
        });
    };
    const handleSelectedSearch = (ele) => {
        serSearchValue(`${ele.PARTY_NAME} (${ele.ACCOUNT_NUMBER})`);
        seSelectedDistributor(ele.ACCOUNT_NUMBER);
        setdistributorSearchResult([]);
        setSelectedDistributorObj(ele);
    };

    const handleDropdown = (order) => {
        setOrderDropDown(!orderDropDown);
        seSelectedOrder(order);
    };
    const orderPlacementCategory = {
        Domestic: ['Consumables', 'Equipments', 'MnR'],
        Service: ['Equipments', 'MnR'],
        Repair: ['Equipments', 'MnR'],
        'Free Supplies': ['Equipments', 'MnR'],
        'Free Service': ['Equipments', 'MnR'],
        Demo: ['Equipments', 'MnR'],
        'Free Samples': ['Consumables', 'MnR'],
        'Free Replacement': ['Equipments', 'MnR'],
    };
    useEffect(() => {
        getUserDetails();
    }, []);

    const orderPlacement = {
        Domestic: ['area_sales_manager', 'area_sales_engineer', 'regional_sales_manager', 'senior_area_sales_engineer'],
        Service: ['area_sales_manager', 'area_sales_engineer', 'regional_sales_manager', 'senior_area_sales_engineer', 'customer_care_centre_head'],
        Repair: ['area_sales_manager', 'area_sales_engineer', 'regional_sales_manager', 'senior_area_sales_engineer', 'customer_care_centre_head'],
        'Free Supplies': ['area_sales_manager', 'area_sales_engineer', 'regional_sales_manager', 'senior_area_sales_engineer', 'customer_care_centre_head'],
        'Free Service': ['customer_care_centre_head'],
        Demo: ['area_sales_manager', 'area_sales_engineer', 'regional_sales_manager', 'senior_area_sales_engineer'],
        'Free Samples': ['area_sales_manager', 'area_sales_engineer', 'senior_area_sales_engineer'],
        'Free Replacement': ['customer_care_centre_head'],
    };
    const { access_privilages, roles, product_categories } = JSON.parse(localStorage.getItem('user')).profile;
    const validate = () => {
        let valid = true;
        if (orderTypes === '') {
            setsubmitSelected(true);
            valid = false;
        }
        if (selectedDistributor === '') {
            setsubmitSelected(true);
            valid = false;
        }
        if (selectedOrder === '') {
            setsubmitSelected(true);
            valid = false;
        }
        if (approveStatus === '') {
            setsubmitSelected(true);
            valid = false;
        }
        if (selectedOrder !== '') {
            if (!orderPlacement[selectedOrder].includes(roles) && access_privilages.includes('orders:create_direct_order')) {
                setsubmitSelected(false);
                setpermissionError(true);
                return false;
            }

            setsubmitSelected(false);
            setpermissionError(false);
        }
        if (selectedOrder === 'Domestic' && selectedDistributorObj.ATTRIBUTE1 === 'Distributor') {
            valid = false;
            setpermissionError(true);
        }

        return valid;
    };

    const CreateOrder = async (e) => {
        if (validate()) {
            setButtonLoader(true);
            e.preventDefault();
            const payload = {};
            payload.cart_items = [];
            payload.po_document = [];
            payload.order_type = selectedOrder;
            payload.distributor_id = selectedDistributor;
            const { roles, email } = JSON.parse(localStorage.getItem('user')).profile;
            payload.user_type = roles;
            payload.initial_category = approveStatus;
            payload.status = -1;
            payload.additional_details = [];
            payload.initiator = email;
            payload.initiator_role = roles;
            try {
                const response = await distributorService.checkDirectOrderEligibility(selectedDistributor, approveStatus);
                if (response.error) {
                    // toast
                    showToast(response?.message?.message || 'Something went wrong', '#ED1C24');
                    setButtonLoader(false);
                } else {
                    const create = await distributorService.CreateOrder(payload);
                    if (!create.error && create.data.success_status) {
                        location(`/manage-orders/direct-order/${selectedDistributor}/${create.data.order_numbers[0]}-1/edit`);
                    }
                    setButtonLoader(false);
                }
            } catch (error) {
                // eslint-disable-next-line no-console
                showToast(response?.message?.error || 'Something went wrong', '#ED1C24');
                console.error(error);
                setButtonLoader(false);
            }
        }
    };
    return (
        <div className={`modal fade fixed top-0 left-0 ${directOrderPopup ? 'show' : 'hidden'} w-full h-full outline-none overflow-x-hidden overflow-y-auto`} id="createdirect" tabIndex="-1" aria-labelledby="deactivateOfferModal" aria-modal="true" role="dialog">
            <div
                className="modal-dialog modal-dialog-centered relative w-auto pointer-events-none sm:max-w-[470px] px-2.5"
                style={{ margin: 'auto' }}
            >
                <div className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
                    <div className="modal-header flex flex-shrink-0 items-center justify-between pt-[26px] rounded-t-md">
                        <h5 className="text-lg font-semibold text-[#090406] text-center w-full" id="exampleModalScrollableLabel1">
                            Create Direct Order
                        </h5>
                        <button
                            type="button"
                            className="absolute top-5 right-5"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={() => { setDirectOrderPopup(); setsubmitSelected(false); }}
                        >
                            <img src="/images/Icon-ionic-ios-close.svg" alt="" />
                        </button>
                    </div>
                    <div className="modal-body relative sm:px-5 px-6 sm:pt-5 pt-4 sm:pb-7 pb-5 text-center">
                        <div>
                            <div className="dropdown relative w-full pb-8">
                                <div className="dropdown relative">
                                    <input
                                        type="text"
                                        id="distributors"
                                        data-bs-toggle="dropdown"
                                        autoComplete="off"
                                        value={searchValue}
                                        className="dropdown-to h-12 w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-lg font-normal text-[#090406] px-3.5 placeholder:text-[#808285] placeholder:font-normal placeholder:text-xs5"
                                        placeholder="Enter Customer Code"
                                        onChange={(e) => {
                                            { onChangeSearch((e.target.value)); setsubmitSelected(false); }
                                        }}
                                    />
                                    {submitSelected && errorState.distributor_id === '' && <span className="text-s font-light text-[#ED1C24]">Customer is required</span>}
                                    <div>
                                        <p className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">
                                            Customer
                                        </p>
                                        {distributorSearchResult
                                            && (
                                                <ul className="dropdown-menu w-full absolute  bg-[#FFFFFF] rounded-lg shadow-s2 z-[9999] max-h-[150px] overflow-auto text-start custom-scrollbar" aria-labelledby="s1">
                                                    {distributorSearchResult && distributorSearchResult.map((ele, fieldIndex) => (
                                                        <li
                                                            className="pl-3.5 w-full pt-3 bg-[#ffffff]"
                                                            key={`dist-${fieldIndex}`}
                                                        >
                                                            <a
                                                                className="dropdown-item text-xs19 font-semibold text-[#090406] mr-3 w-full inline-block territory-inp list"
                                                                // eslint-disable-next-line react/jsx-no-script-url
                                                                href="javascript:void(0)"
                                                                onClick={() => handleSelectedSearch(ele)}
                                                            >
                                                                {ele.PARTY_NAME}
                                                                <span className="text-xs13 ml-3">
                                                                    {ele.ACCOUNT_NUMBER}
                                                                </span>
                                                            </a>
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                    </div>
                                </div>
                            </div>
                            <div className="dropdown relative w-full pb-8">
                                <button
                                    type="button"
                                    onClick={() => {
                                        setOrderDropDown(!orderDropDown);
                                    }}
                                    id="role"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                    className={'h-12 text-left w-full rounded-lg outline-0 border bg-[#FFFFFF] text-lg  font-normal text-[#090406] px-3 border-[\'ED1C24\''}
                                >
                                    <span className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">
                                        Order Type *
                                    </span>
                                    <p id="role" style={{ color: selectedOrder === '' ? 'grey' : 'black' }}>{selectedOrder === '' ? 'Select Direct Order Type' : `${selectedOrder} Order`}</p>
                                    <img src="/images/chevron-red-down1.svg" alt="icon" className="absolute top-[22px] right-5 default-dropdown cursor-pointer" />
                                    {/* : <img src="/images/chevron-red-down.svg" alt="icon" className="absolute top-[22px] right-5 selected selected-dropdown cursor-pointer" /> */}
                                </button>
                                {submitSelected && errorState.order_type === '' && <span className="text-s font-light text-[#ED1C24]">Order Type is required</span>}
                                {orderDropDown
                                    && (
                                        <ul className="dropdown-menu w-full absolute bg-[#FFFFFF] rounded-lg shadow-s2 z-[9999] text-start" aria-labelledby="territory">
                                            {
                                                orderTypes.map((order, index) => (
                                                    <li className="pl-10 w-full pt-3" key={`r-${index}`}>
                                                        <a
                                                            className="dropdown-item text-lg font-normal text-[#555259] w-full inline-block territory-inp"
                                                            href="javascript:void(0)"
                                                            onClick={() => { handleDropdown(order); setsubmitSelected(false); }}
                                                        >
                                                            {order}
                                                            {' '}
                                                            Order
                                                        </a>
                                                    </li>
                                                ))
                                            }

                                        </ul>
                                    )}
                            </div>
                        </div>
                        <div className="modal-body relative sm:px-5 px-3 sm:pt-5 pt-4 sm:pb-7 pb-5 text-center border-t border-[#B1B4B7]">
                            <div>
                                <div className="flex justify-self-start pl-4 pb-4">
                                    <h5>Select Product Category</h5>
                                </div>
                                <div className="tab-pane fade show active px-3" id="pills-pricetab" role="tabpanel" aria-labelledby="pills-priceranje">
                                    <div className="relative">
                                        <div className="cursor-pointer">
                                            {selectedOrder !== '' && orderPlacementCategory[selectedOrder].map((category, categoryIndex) => (
                                                roles && ((roles === 'area_sales_engineer' && (product_categories.includes(category.toUpperCase()) || (category === 'Equipments' && product_categories.includes('EQUIPMENT')) || (category === 'MnR' && product_categories.includes('MnR')))) || roles !== 'area_sales_engineer') && (
                                                    <div className="relative px-2 py-2 cursor-pointer flex">
                                                        <input
                                                            type="radio"
                                                            id={`radio${categoryIndex}`}
                                                            name="radio-group1"
                                                            onChange={() => { setApproveStatus(category); setsubmitSelected(false); }}
                                                            className="cursor-pointer"
                                                            checked={approveStatus === category}
                                                        />
                                                        <label htmlFor={`radio${categoryIndex}`} className="flex w-full">
                                                            <span className="text-sm pl-8 relative cursor-pointer">
                                                                {category}
                                                            </span>
                                                        </label>
                                                    </div>
                                                )
                                            ))}
                                            {/* {roles && ((roles === 'area_sales_engineer' && product_categories.includes('CONSUMABLES')) || roles !== 'area_sales_engineer') && (
                                                <div className="relative px-2 py-2 cursor-pointer flex">
                                                    <input
                                                        type="radio"
                                                        id="radio1"
                                                        name="radio-group1"
                                                        onChange={() => { setApproveStatus('0'); setsubmitSelected(false); }}
                                                        className="cursor-pointer"
                                                        checked={approveStatus === '0'}
                                                    />
                                                    <label htmlFor="radio1" className="flex w-full">
                                                        <span className="text-sm pl-8 relative cursor-pointer">
                                                            Consumables
                                                        </span>
                                                    </label>
                                                </div>
                                            ) }
                                            {roles && ((roles === 'area_sales_engineer' && (product_categories.includes('EQUIPMENTS') || product_categories.includes('EQUIPMENT'))) || roles !== 'area_sales_engineer') && (
                                                <div className="relative px-2 py-2 cursor-pointer flex">
                                                    <input
                                                        type="radio"
                                                        id="radio3"
                                                        name="radio-group1"
                                                        onChange={() => { setApproveStatus('1'); setsubmitSelected(false); }}
                                                        className="cursor-pointer"
                                                        checked={approveStatus === '1'}
                                                    />
                                                    <label htmlFor="radio3" className="flex w-full">
                                                        <span className="text-sm pl-8 relative cursor-pointer">
                                                            Equipments
                                                        </span>
                                                    </label>
                                                </div>
                                            )} */}
                                            {submitSelected && errorState.order_type === '' && <span className="text-s font-light text-[#ED1C24]">Product Category is required</span>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {permissionError && <span className="text-s font-light text-[#ED1C24]">You can't place this Order</span>}
                            <div className="pt-3 justify-center ">
                                <button
                                    type="button"
                                    className="w-full sm:h-10 h-9 border border-[#555259] bg-[#555259] rounded-lg text-sm font-semibold apply text-[#FFFFFF]"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    onClick={(e) => { CreateOrder(e); }}
                                >
                                    {buttonLoader ? <div className="pl-[185px]"><ThreeDotsLoader /></div> : 'Create Order'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
}

export default CreateDirectOrderPopup;
